import {
  Badge,
  BadgeSize,
  BadgeVariant,
  IconButton,
  IconButtonVariant
} from "shared/components";
import { Cancel01Icon, Tick02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { cx } from "shared/utils";

interface HeaderProps {
  onClose: () => void;
  recommendationTitle: string;
  recommendationVariant: BadgeVariant;
}

export const Header = ({
  onClose,
  recommendationTitle,
  recommendationVariant
}: HeaderProps) => {
  return (
    <header className="w-full rounded-t-md bg-white py-5 px-6">
      <div className="flex justify-between items-start">
        <h1 className="text-content-1000 font-bold text-xl">
          Decision recommendation details
        </h1>

        <IconButton
          variant={IconButtonVariant.TEXT_BASE}
          className="stroke-content-200"
          onClick={onClose}
          HugeIcon={Cancel01Icon}
        />
      </div>
      <Badge
        className="mt-3 !font-bold items-center"
        variant={recommendationVariant}
        size={BadgeSize.LG}
        leftElement={
          [BadgeVariant.SUCCESS, BadgeVariant.WARNING].includes(
            recommendationVariant
          ) ? (
            <HugeiconsIcon
              icon={Tick02Icon}
              size={14}
              strokeWidth={3}
              className={cx(
                recommendationVariant === BadgeVariant.SUCCESS
                  ? "text-success-700"
                  : "text-warning-700"
              )}
            />
          ) : (
            <HugeiconsIcon
              icon={Cancel01Icon}
              size={14}
              strokeWidth={3}
              className="text-danger-500"
            />
          )
        }
      >
        {recommendationTitle}
      </Badge>
    </header>
  );
};
